import { useState } from "react";
import { MANDALA_CONCEPTS } from "@/data/content";
import { Eyebrow } from "@/components/common";

export default function Mandala() {
  const [active, setActive] = useState(MANDALA_CONCEPTS[0]);
  const R = 150;
  const cx = 200, cy = 200;

  return (
    <div className="pt-16 lg:pt-[72px]" data-testid="mandala-page">
      <section className="py-14 lg:py-20 border-b border-indic-gold/15">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-8">
          <Eyebrow>Mandala Explorer</Eyebrow>
          <h1 className="mt-3 font-serif text-5xl lg:text-6xl font-semibold text-amber-50">The Wheel of Concepts</h1>
          <p className="mt-4 max-w-2xl text-lg text-slate-300/90 leading-relaxed">Core ideas of Indic philosophy, arranged as a mandala. Select a node to reflect on its meaning.</p>
        </div>
      </section>

      <section className="py-14 lg:py-20">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-8 grid lg:grid-cols-2 gap-10 items-center">
          <div className="flex justify-center" data-testid="mandala-svg">
            <svg viewBox="0 0 400 400" className="w-full max-w-md">
              <defs>
                <radialGradient id="mg" cx="50%" cy="50%" r="50%">
                  <stop offset="0%" stopColor="#D4AF37" stopOpacity="0.25" />
                  <stop offset="100%" stopColor="#0B1021" stopOpacity="0" />
                </radialGradient>
              </defs>
              <circle cx={cx} cy={cy} r={R + 30} fill="url(#mg)" />
              {[R, R * 0.66, R * 0.33].map((r, i) => (
                <circle key={i} cx={cx} cy={cy} r={r} fill="none" stroke="#D4AF37" strokeOpacity="0.2" strokeWidth="1" />
              ))}
              {MANDALA_CONCEPTS.map((c) => {
                const a = (c.angle * Math.PI) / 180;
                const x = cx + R * Math.cos(a - Math.PI / 2);
                const y = cy + R * Math.sin(a - Math.PI / 2);
                return <line key={`ln-${c.name}`} x1={cx} y1={cy} x2={x} y2={y} stroke="#D4AF37" strokeOpacity={active.name === c.name ? 0.5 : 0.12} strokeWidth="1" />;
              })}
              {MANDALA_CONCEPTS.map((c) => {
                const a = (c.angle * Math.PI) / 180;
                const x = cx + R * Math.cos(a - Math.PI / 2);
                const y = cy + R * Math.sin(a - Math.PI / 2);
                const on = active.name === c.name;
                return (
                  <g key={c.name} onClick={() => setActive(c)} className="cursor-pointer" data-testid={`mandala-node-${c.name.toLowerCase()}`}>
                    <circle cx={x} cy={y} r={on ? 30 : 24} fill={on ? "#D4AF37" : "#131B33"} stroke="#D4AF37" strokeOpacity={on ? 1 : 0.4} strokeWidth="1.5" />
                    <text x={x} y={y + 4} textAnchor="middle" fontSize="11" fontFamily="Cormorant Garamond, serif" fill={on ? "#0B1021" : "#E7CE82"}>{c.name}</text>
                  </g>
                );
              })}
              <circle cx={cx} cy={cy} r="34" fill="#131B33" stroke="#D4AF37" strokeOpacity="0.5" />
              <text x={cx} y={cy - 2} textAnchor="middle" fontSize="13" fontFamily="Cinzel, serif" fill="#D4AF37">इ</text>
              <text x={cx} y={cy + 14} textAnchor="middle" fontSize="8" fill="#9aa">INDIC</text>
            </svg>
          </div>

          <div className="rounded-sm border border-indic-card-border bg-indic-card p-8" data-testid="mandala-detail">
            <div className="font-deva text-3xl text-indic-gold">{active.name}</div>
            <div className="mt-1 font-serif italic text-xl text-amber-100/80">{active.en}</div>
            <div className="mt-5 h-px w-16 bg-indic-gold/40" />
            <p className="mt-5 text-lg text-slate-300/90 leading-relaxed">{active.desc}</p>
            <div className="mt-8 flex flex-wrap gap-2">
              {MANDALA_CONCEPTS.map((c) => (
                <button key={c.name} onClick={() => setActive(c)} className={`rounded-full px-3 py-1 text-sm transition-colors ${active.name === c.name ? "bg-indic-gold text-indic-indigo" : "border border-indic-card-border text-slate-400 hover:text-amber-50"}`}>{c.name}</button>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
